import { createContext, useContext } from 'react';
import type { TourContextValue } from './types';

const TourContext = createContext<TourContextValue | null>(null);

export const TourProvider = TourContext.Provider;

export const useTourContext = (): TourContextValue | null =>
  useContext(TourContext);

export const useTourContextRequired = (): TourContextValue => {
  const value = useContext(TourContext);
  if (!value) {
    throw new Error('useTourContextRequired must be used within TourProvider');
  }
  return value;
};
